import React from 'react';
import { Box, TextField, Button, MenuItem } from '@mui/material';
import MobileSearchAdornment from '../../../common/search/MobileSearchAdornment';

const EmpListBox = ({ formik, multi, onSelectedRows }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
                alignItems: 'center',
                my: 1,
            }}
        >
            <Box
                component="form"
                noValidate
                autoComplete="off"
                sx={{
                    flexGrow: 1,
                    display: { xs: 'contents', sm: 'flex' },
                    flexDirection: 'row',
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                    justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                    alignItems: 'center',
                    rowGap: 1,
                    mr: 2,
                }}
                onSubmit={formik.handleSubmit}
            >
                <Box
                    sx={{
                        order: { xs: 1, sm: 0 },
                        flex: { xs: 1, sm: '0 1 auto' },
                        minWidth: 0,
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'nowrap',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        '& > :not(style)': { m: { xs: 0.5, sm: 1 }, width: { sm: '25ch' } },
                        '& > :first-of-type': { flex: { xs: '0 0 38%', sm: '0 1 auto' } },
                        '& > :last-of-type': { flex: { xs: 1, sm: '0 1 auto' } },
                    }}
                >
                    <TextField
                        variant="standard"
                        required
                        select
                        id="searchKeyword"
                        name="searchKeyword"
                        label="검색키워드"
                        value={formik.values.searchKeyword}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.searchKeyword &&
                            Boolean(formik.errors.searchKeyword)
                        }
                        helperText={
                            formik.touched.searchKeyword && formik.errors.searchKeyword
                        }
                    >
                        <MenuItem value="usrNm">이름</MenuItem>
                        <MenuItem value="usrNo">사번</MenuItem>
                        <MenuItem value="dptNm">부서</MenuItem>
                        <MenuItem value="gradeNm">직급</MenuItem>
                        <MenuItem value="telNo">연락처</MenuItem>
                        <MenuItem value="emlAddr">이메일</MenuItem>
                    </TextField>
                    <TextField
                        variant="standard"
                        required
                        id="searchWords"
                        name="searchWords"
                        label="검색어"
                        onChange={formik.handleChange}
                        error={
                            formik.touched.searchWords && Boolean(formik.errors.searchWords)
                        }
                        helperText={
                            formik.touched.searchWords && formik.errors.searchWords
                        }
                        InputProps={{
                            endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        order: { xs: 2, sm: 0 },
                        flex: { xs: '0 0 auto', sm: '0 1 auto' },
                        display: { xs: 'none', sm: 'block' },
                    }}
                >
                    <Button
                        type="submit"
                        color="info"
                        variant="contained"
                        disabled={formik.isSubmitting}
                    >
                        검색
                    </Button>
                    {multi && (
                        <Button
                            sx={{ ml: 1 }}
                            color="secondary"
                            variant="contained"
                            onClick={onSelectedRows}
                        >
                            선택
                        </Button>
                    )}
                </Box>
                {multi && (
                    <Box sx={{ order: { xs: 3, sm: 0 }, display: { xs: 'block', sm: 'none' } }}>
                        <Button
                            size="small"
                            color="secondary"
                            variant="contained"
                            onClick={onSelectedRows}
                        >
                            선택
                        </Button>
                    </Box>
                )}
            </Box>

        </Box>
    )
}

export default EmpListBox